import React, {Fragment, useRef, useState} from 'react';
import {Col, Overlay, Row} from 'react-bootstrap';

import {AddColumnPopover} from './Popovers/AddColumnPopover';
import {useColumnDragAndResize, useQueryTableController, useTableScrollbarEnhance} from '../../../../Hooks/QueryToolTableHooks';
import {PaginationComponent} from '../PaginationComponent';
import {QueryToolHeaderRow} from './HeaderRow';
import {QueryToolBody} from './Body';
import {QueryToolEmptyState} from './EmptyState';

export const QueryToolTable = ({Title, FilterComponent}) => {
    const targetNode = useRef(null);
    const tableBodyRef = useRef(null);
    const [dataTable, setDataTable] = useState(null);

    const dataTableRefCallback = (node) => {
        setDataTable(node);
    };

    useTableScrollbarEnhance(dataTable);

    const {handleDragEnd, handleResizeHover, handleResizeLeave} = useColumnDragAndResize();

    const {
        table,
        columns,
        isStale,
        showAdd,
        saveNewColumns,
        cancelAdd,
        handlePopoverHide,
        handleAddColumnClick,
    } = useQueryTableController({tableBodyRef});

    const renderAddColumnPopover = () => (
        <Overlay
            container={targetNode}
            target={targetNode.current}
            onHide={handlePopoverHide}
            show={showAdd}
            rootClose={true}
        >
            <AddColumnPopover saveNewColumns={saveNewColumns} cancelAdd={cancelAdd} />
        </Overlay>
    );

    const headerGroups = table.getHeaderGroups();
    const rowModel = table.getRowModel();
    const totalSize = table.getTotalSize();
    const allColumns = table.getAllColumns();

    const tableClassName = `rt-table -striped -highlight ${isStale ? 'stale' : ''} ${showAdd ? 'sb-query-tool-modal-backdrop' : ''}`;

    return (
        <Fragment>
            <Title />
            <div>
                <hr className="special-hr"/>
            </div>
            <Row>
                <Col xs={12}>
                    <div ref={targetNode}>
                        {renderAddColumnPopover()}
                    </div>
                    <Row key="filters">
                        <FilterComponent />
                    </Row>
                    {columns.length ? (
                        <div className="ReactTable">
                            <div
                                ref={dataTableRefCallback}
                                className={tableClassName}
                            >
                                <QueryToolHeaderRow
                                    headerGroups={headerGroups}
                                    totalSize={totalSize}
                                    onDragEnd={handleDragEnd}
                                    onResizeHover={handleResizeHover}
                                    onResizeLeave={handleResizeLeave}
                                />
                                <QueryToolBody
                                    tableBodyRef={tableBodyRef}
                                    rows={rowModel.rows}
                                    totalSize={totalSize}
                                    allColumns={allColumns}
                                />
                            </div>
                            <PaginationComponent
                                getPageCount={table.getPageCount}
                                getCanNextPage={table.getCanNextPage}
                                getCanPreviousPage={table.getCanPreviousPage}
                            />
                        </div>
                    ) : (
                        <QueryToolEmptyState onStartQuery={handleAddColumnClick} />
                    )}
                </Col>
            </Row>
        </Fragment>
    );
};
